/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-06-17 23:06:56
 * @LastEditTime: 2020-10-23 09:39:35
 * @LastEditors: Please set LastEditors
 */

import axios from 'axios';
import { Message } from 'element-ui';
let service = axios.create({
  headers: {}
})

// 添加请求拦截器
service.interceptors.request.use(function (config) {
  // 在发送请求之前做些什么
  return config
}, function (error) {
  // 对请求错误做些什么
  return Promise.reject(error)
})

// 添加响应拦截器
service.interceptors.response.use(function (response) {
  // 对响应数据做点什么
  let data = response.data
  if (data.code) {
    Message({message: data.msg, type: 'warning'})
  }
  return data
}, function (error) {
  // 对响应错误做点什么
  return Promise.reject(error)
})

export default service



// WEBPACK FOOTER //
// ./src/plugins/axios.js